import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/v4ward/car/cardeptspace/page/v2',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/v4ward/car/cardeptspace/detail/v2',
    method: 'get',
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: '/api/v4ward/car/cardeptspace/remove/v2',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/v4ward/car/cardeptspace/submit/v2',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/v4ward/car/cardeptspace/submit/v2',
    method: 'post',
    data: row,
  });
};
